import axios from 'axios'
import api_url from '../urls'
const actions = {

  async  addPergunta (context, value) {
   // console.log(value)

    context.commit('PRELOADER_MUDAR', true)
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))

    await axios.post(api_url.api_admin + 'v1/admin/add_pergunta',
      {
        nome: value.titulo,
        a: value.a,
        b: value.b,
        c: value.c,
        d: value.d,
        e: value.e,
        resposta: value.resposta,
        disciplina_id: value.disciplina_id,
        status: 1,
        valor: 1,

      },
      {
        headers: {
          'Authorization': AuthStr,
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
      //  console.log(response.data)

        // context.commit('SET_PERGUNTAS', response.data)
      })
      .catch((error) => {
       // console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },
  
  async  addAvaliacao (context, value) {
    // console.log(value)

    context.commit('PRELOADER_MUDAR', true)
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))

    await axios.post(api_url.api_admin + 'v1/admin/add_avaliacao',
      {
        
        nome: value.nome,
        data_abertura: value.data_abertura,
        data_encerramento: value.data_encerramento,
        tipo_Avaliacao_id: 1,
        oferta_data_disciplina_id: value.oferta_data_disciplina_id,
        status: 1

      },
      {
        headers: {
          'Authorization': AuthStr,
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        // console.log(response.data)
        // context.commit('SET_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error)
        // console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  async  addOfertaPergunta (context, value) {
    console.log(value)

    context.commit('PRELOADER_MUDAR', true)
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))

    await axios.post(api_url.api_admin + 'v1/admin/add_oferta_pergunta',
      {
       descricao: '',
       status: 1,
       ead_pergunta_id: value.ead_pergunta_id,
       ead_avaliacao_id: value.ead_avaliacao_id
      },
      {
        headers: {
          'Authorization': AuthStr,
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        // console.log(response.data)
        // context.commit('SET_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  AllPerguntas (context, value) {
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
    axios.get(api_url.api_admin + 'v1/admin/all_perguntas/'+ value,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
         console.log(response.data)
         context.commit('GET_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },
  allPerguntas (context, value) {
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
    axios.get(api_url.api_admin + 'v1/admin/allPerguntas',
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
         console.log(response.data)
         context.commit('ALL_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  async allOfertaPerguntasAvaliacao_2 (context, value) {
    //console.log(value);
     context.commit('PRELOADER_MUDAR', true)
 
     const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
   await  axios.get(api_url.api_admin + 'v1/admin/get_oferta_perguntas_avaliacao/'+ value.id,
       {
         headers: {
           'authorization': AuthStr,
           'Accept': 'application/json',
           'Content-Type': 'application/json',
         },
       })
       .then(response => {
         console.log(response.data)
          context.commit('GET_OFERTA_PERGUNTAS', response.data)
       })
       .catch((error) => {
         console.log(error.response.data.message)
       }).finally(() => context.commit('PRELOADER_MUDAR', false))
   },

 async allOfertaPerguntasAvaliacao (context, value) {
   console.log(value)
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/get_oferta_perguntas/'+ value.ead_avaliacao_id+'/'+value.id,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        // console.log(response.data)
         context.commit('GET_OFERTA_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },
 
 async allAvaliacoes (context, value) {
    // console.log(value)
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/all_avaliacoes/'+value,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log(response.data)
         context.commit('GET_AVALIACOES', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },
  async getAvaliacoesRealizadas (context, value) {
    // console.log(value)
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/getAvaliacoesRealizadas/'+value.avaliacao_id+'/'+value.aluno_id,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log(response.data)
         context.commit('GET_AVALIACOES_REALIZADAS', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },


  async allPerguntaAvaliacao (context, value) {
    // console.log(value)
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/allPerguntaAvaliacao/'+1,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log(response.data)
         context.commit('GET_PERGUNTAS_AVALIACAO', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },
  setAvaliacao(context,value ){
    context.commit('SET_AVALIACAO', value)
  },

  async allAvaliacoesCurso (context, value) {
    // console.log(value)
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/all_avaliacoes_curso/'+value,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log(response.data)
         context.commit('GET_AVALIACOES', response.data)
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  async  addTentativa (context, value) {
    // console.log(value)

    context.commit('PRELOADER_MUDAR', true)
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))

    await axios.post(api_url.api_admin + 'v1/admin/addTentativa',
      {
        
        aluno_id: value.aluno_id,
        ead_avaliacao_id: value.avaliacao_id,
        status: 1

      },
      {
        headers: {
          'Authorization': AuthStr,
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
         console.log(response.data)
        // context.commit('SET_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error)
        // console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

 async getPergunta (context, value) {
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/getPergunta/'+ value.pergunta_id +'/'+ value.tentativa_id,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        // console.log(response.data[0])
         context.commit('GET_PERGUNTA', response.data[0])
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  async  addRespostaPergunta (context, value) {
 
    context.commit('PRELOADER_MUDAR', true)
    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))

    await axios.post(api_url.api_admin + 'v1/admin/addRespostaPergunta',
      {
        resposta: value.resposta,
        ead_avaliacao_aluno_id: value.ead_avaliacao_aluno_id,
        ead_oferta_pergunta_id: value.ead_oferta_pergunta_id,
        status: 1

      },
      {
        headers: {
          'Authorization': AuthStr,
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
       //  console.log(response.data)
        // context.commit('SET_PERGUNTAS', response.data)
      })
      .catch((error) => {
        console.log(error)
        // console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

  async InserirTempoTentativa (context, value) {
    context.commit('PRELOADER_MUDAR', true)

    const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
  await  axios.get(api_url.api_admin + 'v1/admin/InserirTempoTentativa/'+ value,
      {
        headers: {
          'authorization': AuthStr,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        // console.log(response.data[0])
        // context.commit('GET_PERGUNTA', response.data[0])
      })
      .catch((error) => {
        console.log(error.response.data.message)
      }).finally(() => context.commit('PRELOADER_MUDAR', false))
  },

}

export default actions
